export const PAW_VIEWED_INTRO_PAGE = 'pact-act/PAW_VIEWED_INTRO_PAGE';
export const PAW_UPDATE_SERVICE_PERIOD = 'pact-act/PAW_UPDATE_SERVICE_PERIOD';
export const PAW_UPDATE_BURN_PIT_2_1 = 'pact-act/PAW_UPDATE_BURN_PIT_2_1';
export const PAW_UPDATE_BURN_PIT_2_1_1 = 'pact-act/PAW_UPDATE_BURN_PIT_2_1_1';
export const PAW_UPDATE_BURN_PIT_2_1_2 = 'pact-act/PAW_UPDATE_BURN_PIT_2_1_2';
export const PAW_UPDATE_BURN_PIT_2_1_3 = 'pact-act/PAW_UPDATE_BURN_PIT_2_1_3';
export const PAW_UPDATE_ORANGE_2_2_A = 'pact-act/PAW_UPDATE_ORANGE_2_2_A';
export const PAW_UPDATE_ORANGE_2_2_B = 'pact-act/PAW_UPDATE_ORANGE_2_2_B';
export const PAW_UPDATE_ORANGE_2_2_1_A = 'pact-act/PAW_UPDATE_ORANGE_2_2_1_A';
export const PAW_UPDATE_ORANGE_2_2_1_B = 'pact-act/PAW_UPDATE_ORANGE_2_2_1_B';
export const PAW_UPDATE_ORANGE_2_2_2 = 'pact-act/PAW_UPDATE_ORANGE_2_2_2';
export const PAW_UPDATE_ORANGE_2_2_3 = 'pact-act/PAW_UPDATE_ORANGE_2_2_3';
export const PAW_UPDATE_RADIATION_2_3_A = 'pact-act/PAW_UPDATE_RADIATION_2_3_A';
export const PAW_UPDATE_RADIATION_2_3_B = 'pact-act/PAW_UPDATE_RADIATION_2_3_B';
export const PAW_UPDATE_LEJEUNE_2_4 = 'pact-act/PAW_UPDATE_LEJEUNE_2_4';
export const PAW_UPDATE_MAIN_FLOW_2_5 = 'pact-act/PAW_UPDATE_MAIN_FLOW_2_5';
export const PAW_UPDATE_FORM_STORE = 'pact-act/PAW_UPDATE_FORM_STORE';

// Except for HOME and results pages, left side must match
// short name codes in constants/question-data-map
export const ROUTES = Object.freeze({
  HOME: 'introduction',
  SERVICE_PERIOD: 'service-period-1',
  BURN_PIT_2_1: 'burn-pit-2-1',
  BURN_PIT_2_1_1: 'burn-pit-2-1-1',
  BURN_PIT_2_1_2: 'burn-pit-2-1-2',
  BURN_PIT_2_1_3: 'burn-pit-2-1-3',
  ORANGE_2_2_A: 'agent-orange-2-2-A',
  ORANGE_2_2_B: 'agent-orange-2-2-B',
  ORANGE_2_2_1_A: 'agent-orange-2-2-1-A',
  ORANGE_2_2_1_B: 'agent-orange-2-2-1-B',
  ORANGE_2_2_2: 'agent-orange-2-2-2',
  ORANGE_2_2_3: 'agent-orange-2-2-3',
  RADIATION_2_3_A: 'radiation-2-3-A',
  RADIATION_2_3_B: 'radiation-2-3-B',
  LEJEUNE_2_4: 'lejeune-2-4',
  MAIN_FLOW_2_5: 'main-2-5',
  RESULTS_1_1: 'results-1-1',
  RESULTS_1_2: 'results-1-2',
  RESULTS_2: 'results-2',
  RESULTS_3: 'results-3',
  RESULTS_4: 'results-4',
});
